import { render, staticRenderFns } from "./clearRoom.vue?vue&type=template&id=15390209&scoped=true"
import script from "./clearRoom.vue?vue&type=script&lang=js"
export * from "./clearRoom.vue?vue&type=script&lang=js"
import style0 from "./clearRoom.vue?vue&type=style&index=0&id=15390209&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15390209",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15390209')) {
      api.createRecord('15390209', component.options)
    } else {
      api.reload('15390209', component.options)
    }
    module.hot.accept("./clearRoom.vue?vue&type=template&id=15390209&scoped=true", function () {
      api.rerender('15390209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/clearRoom.vue"
export default component.exports